// src/features/rrhh/empleados/components/EmpleadosTable.jsx
import { Box, Button, Stack, Typography } from "@mui/material";

export default function EmpleadosTable({
  rows = [],
  selectedId = null,
  onSelect,
  onEdit,
  height = 250,
}) {
  const Cell = ({ value }) => (
    <Typography sx={{ color: "primary.900", fontSize: 14, textAlign: "center" }}>
      {value}
    </Typography>
  );

  return (
    <Box sx={{ borderRadius: "20px", overflow: "hidden" }}>
      {/* Header */}
      <Box sx={{ display: "flex", bgcolor: "neutral.600", px: 2, py: 1.6 }}>
        {["Nombre", "DNI", "Fecha alta", "Situación", "Contrato", "Acción"].map((h) => (
          <Typography
            key={h}
            sx={{ flex: 1, fontSize: 14, fontWeight: 700, color: "logoblanco", textAlign: "center" }}
          >
            {h}
          </Typography>
        ))}
      </Box>

      {/* Body */}
      <Box sx={{ bgcolor: "neutral.50", height, overflowY: "auto" }}>
        {rows.map((e) => {
          const selected = e.id === selectedId;

          return (
            <Box
              key={e.id}
              onClick={() => onSelect?.(e.id)}
              sx={{
                px: 2,
                py: 1.2,
                cursor: "pointer",
                borderBottom: "1px solid rgba(0,0,0,.06)",
                bgcolor: selected ? "secondary.50" : "transparent",
                "&:hover": { bgcolor: selected ? "secondary.50" : "rgba(0,0,0,.03)" },
              }}
            >
              <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
                <Box sx={{ flex: 1 }}><Cell value={e.nombre} /></Box>
                <Box sx={{ flex: 1 }}><Cell value={e.dni} /></Box>
                <Box sx={{ flex: 1 }}><Cell value={e.fechaAlta} /></Box>
                <Box sx={{ flex: 1 }}><Cell value={e.situacion} /></Box>
                <Box sx={{ flex: 1 }}><Cell value={e.contrato} /></Box>
                <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      onEdit?.(e.id);
                    }}
                    sx={{
                      minWidth: 108,
                      py: 0.5,
                      px: 1.2,
                      borderRadius: "20px",
                      bgcolor: "secondary.500",
                      textTransform: "none",
                      "&:hover": { bgcolor: "secondary.600" },
                    }}
                  >
                    <Typography sx={{ color: "logoblanco", fontSize: 12, fontWeight: 700 }}>
                      Ver ficha
                    </Typography>
                  </Button>
                </Box>
              </Stack>
            </Box>
          );
        })}

        {rows.length === 0 && (
          <Box sx={{ p: 3 }}>
            <Typography sx={{ color: "neutral.700" }}>
              No hay resultados para los filtros actuales.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
